module.exports = "/work-site/img/leave.0eac2d1e.png";